declare global {
  interface Window {
    dataLayer: Array<{}>;
    google: google.maps.Map;
  }
}

export class GoogleTagManager {
  private dataLayer: Array<{}>;

  constructor() {
    this.dataLayer = window.dataLayer = window.dataLayer || [];
  }

  send(data: {}) {
    // Reset custom_event and ecommerce data in the dataLayer to avoid data leakage between events
    this.push({ custom_event: null, ecommerce: null });
    this.push(data);
    return this;
  }

  private push(data: {}) {
    this.dataLayer.push(data);
  }
}
